var map = {
	"./anz-1": 72674,
	"./anz-1.ts": 72674,
	"./anz-2": 70599,
	"./anz-2.ts": 70599,
	"./asia-1": 30679,
	"./asia-1.ts": 30679,
	"./asia-3": 793,
	"./asia-3.ts": 793,
	"./asia-4": 58996,
	"./asia-4.ts": 58996,
	"./asia-5": 4243,
	"./asia-5.ts": 4243,
	"./asia-6": 8510,
	"./asia-6.ts": 8510,
	"./asia-7": 4341,
	"./asia-7.ts": 4341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59170;